import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import { UIText1 } from '@cian/ui-kit/typography';

import { TResponseRateType } from '../../../types/responseRateType';

import * as styles from './ResponseRateMobile.css';

interface IResponseRateMobileProps {
  rateType: TResponseRateType;
  rateValue: number;
}

const getRateStyles = (rateType: TResponseRateType) =>
  mergeStyles(styles['rate'], rateType === 'high' ? styles['rate_high'] : styles['rate_low']);

const getTextColor = (rateType: TResponseRateType) => (rateType === 'high' ? 'success_100' : 'warning_100');

export const ResponseRateMobile: React.FunctionComponent<React.PropsWithChildren<IResponseRateMobileProps>> = ({
  rateType,
  rateValue,
}) => (
  <div>
    <span {...getRateStyles(rateType)}>
      <UIText1 color={getTextColor(rateType)}>{rateValue}%</UIText1>
    </span>
    <span> </span>
    <UIText1>частота ответов</UIText1>
  </div>
);
